/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetClientRefRequest
 */
export interface SetClientRefRequest {
    /**
     * Custom reference string (max 100 characters), or `null` to clear it.
     */
    clientRef: string | null;
}

/**
 * Check if a given object implements the SetClientRefRequest interface.
 */
export function instanceOfSetClientRefRequest(value: object): value is SetClientRefRequest {
    if (!('clientRef' in value) || value['clientRef'] === undefined) return false;
    return true;
}

export function SetClientRefRequestFromJSON(json: any): SetClientRefRequest {
    return SetClientRefRequestFromJSONTyped(json, false);
}

export function SetClientRefRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetClientRefRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientRef': json['clientRef'],
    };
}

export function SetClientRefRequestToJSON(json: any): SetClientRefRequest {
    return SetClientRefRequestToJSONTyped(json, false);
}

export function SetClientRefRequestToJSONTyped(value?: SetClientRefRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientRef': value['clientRef'],
    };
}

